<nav class="top-sub-nav" role="navigation" aria-label="Secondary">
  <button
    neo-button
    size="sm"
    color="gray"
    class="current-program-btn"
    [wrap]="false"
    [iconOnly]="false"
    [disabled]="false"
    aut-id="current-program-button"
    (click)="onCurrentProgramClick()"
    [attr.aria-label]="getCurrentProgramAriaLabel()"
    tabindex="0"
  >
    <span class="current-program-btn-content">
      @if (isMobile) { @if (subnavFull) {
      <a360-icon
        icon="arrow-left"
        [width]="'16px'"
        [height]="'16px'"
        [color]="'var(--secondary-text-color)'"
      ></a360-icon>
      } @if (subnavHidden) {
      <a360-icon
        icon="arrow-right"
        [width]="'16px'"
        [height]="'16px'"
        [color]="'var(--secondary-text-color)'"
      ></a360-icon>
      } }
      {{ currentProgramName }}
    </span>
  </button>

  <div class="notifications-wrapper">
    <button
      neo-button
      (click)="toggleNotifications()"
      size="sm"
      color="gray"
      [wrap]="false"
      [iconOnly]="false"
      [disabled]="false"
      aria-label="Notifications"
      aut-id="notifications-button"
      tabindex="0"
      [attr.aria-expanded]="notificationsOpen"
      aria-controls="notifications-dialog"
    >
      Notifications
    </button>
    @if (notificationCount > 0) {
    <output
      [neoBadge]="notificationCount"
      [neoBadgeDescription]="notificationCount + ' Notifications'"
      aria-live="polite"
      aria-atomic="true"
    >
      <span class="sr-only"> {{ notificationCount }} Notifications </span>
    </output>
    }
  </div>
</nav>
